import { DragFn } from '../../features/calendar/components/time-block/interaction/movement/interact-handler.service';
import { ITimeBlockComponentItem } from '../../features/calendar/components/time-block/types/time-block-component-item-types';

export type InteractCallbackFns = {
  init?: (timeBlock: ITimeBlockComponentItem) => ITimeBlockComponentItem;
  startFn?: DragFn;
  dragFn?: DragFn;
  endFn?: DragFn;
};

export enum DragOrResizeInteraction {
  None,
  Drag,
  Resize,
}
